var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import ShopActivityService from '../../../api/ShopActivityService';
import { toDetail } from '../../../helper/util';
import { EBillType } from '../../../enum/EBillType';
import RecordSubTable from './recordSubTable';
import GlobalVue from "../../../globalVue";
import PointDetail from "./PointDetail.vue";
var initFilterData = {
    shop_id: null,
    order_id: null,
};
var ShopActivityRecordTable = (function (_super) {
    __extends(ShopActivityRecordTable, _super);
    function ShopActivityRecordTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pointDetailVisible = false;
        return _this;
    }
    ShopActivityRecordTable.prototype.created = function () {
        this.service = ShopActivityService.getInstance();
    };
    ShopActivityRecordTable.prototype.toOrderDetail = function (order_id) {
        toDetail(EBillType.PurOrder, order_id, this);
    };
    ShopActivityRecordTable.prototype.toPointDetail = function (row) {
        console.log(row, 88);
        this.addTab({
            component: PointDetail,
            title: "\u5BA2\u6237\u79EF\u5206\u660E\u7EC6",
            showExist: true,
            name: 'PointDetailList',
            cprops: {
                activity_id: this.formData.activity_id,
                business_id: row.business_id
            },
        });
        this.pointDetailVisible = true;
        window._czc.push(['_trackEvent', '营销活动', "\u5BA2\u6237\u660E\u7EC6\u79EF\u5206"]);
    };
    ShopActivityRecordTable.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    ShopActivityRecordTable.prototype.expandChange = function (row, expandedRows) {
        if (expandedRows.length == 0) {
            return;
        }
        this.getActOrderLogList(row.business_id);
    };
    ShopActivityRecordTable.prototype.getActOrderLogList = function (business_id, pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var params = __assign({ activity_id: this.activityId, business_id: business_id }, pager);
        var business_ids = this.listData.map(function (v) { return v.business_id; });
        var index = business_ids.indexOf(business_id);
        this.service.getActOrderLogList(params).then(function (res) {
            var listOrders = Array.isArray(res.data.data) ? res.data.data : [];
            var listOrdersTotal = res.data.total || 0;
            GlobalVue.$set(_this.listData[index], 'listOrders', listOrders);
            GlobalVue.$set(_this.listData[index], 'listOrdersTotal', listOrdersTotal);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    __decorate([
        Prop({
            required: true,
        })
    ], ShopActivityRecordTable.prototype, "activityId", void 0);
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], ShopActivityRecordTable.prototype, "listData", void 0);
    __decorate([
        Prop({
            type: Number,
            default: []
        })
    ], ShopActivityRecordTable.prototype, "tableHeight", void 0);
    __decorate([
        Prop({
            type: Object,
            default: []
        })
    ], ShopActivityRecordTable.prototype, "formData", void 0);
    ShopActivityRecordTable = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
            })),
            methods: __assign({}, mapActions(["getAuth"])),
            components: {
                RecordSubTable: RecordSubTable,
                PointDetail: PointDetail
            },
        })
    ], ShopActivityRecordTable);
    return ShopActivityRecordTable;
}(Vue));
export default ShopActivityRecordTable;
